"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardProductionBoxComponent = void 0;
const vue_1 = require("vue");
const CardRenderItemComponent_1 = require("./CardRenderItemComponent");
const CardRenderSymbolComponent_1 = require("./CardRenderSymbolComponent");
const CardRenderSymbol_1 = require("../../cards/render/CardRenderSymbol");
const CardRenderItem_1 = require("../../cards/render/CardRenderItem");
exports.CardProductionBoxComponent = vue_1.default.component('CardProductionBoxComponent', {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
        CardRenderSymbolComponent: CardRenderSymbolComponent_1.CardRenderSymbolComponent,
    },
    methods: {
        getClasses: function () {
            const classes = ['card-production-box'];
            return classes.join(' ');
        },
        getComponentType: function (rowItem) {
            if (rowItem instanceof CardRenderSymbol_1.CardRenderSymbol) {
                return 'symbol';
            }
            else if (rowItem instanceof CardRenderItem_1.CardRenderItem) {
                return 'item';
            }
            return '';
        },
    },
    template: `
        <div :class="getClasses()">
            <div class="card-production-box-row" v-for="(rowData, index) in rows" :key="index">
                <div v-for="(rowItem, rowIndex) in rowData" class="card-production-box-row-item" :key="rowIndex">
                    <CardRenderItemComponent v-if="getComponentType(rowItem) === 'item'" :item="rowItem"/>
                    <CardRenderSymbolComponent v-else-if="getComponentType(rowItem) === 'symbol'" :item="rowItem" />
                    <div v-else>n/a</div>
                </div>
            </div>
        </div>
    `,
});
//# sourceMappingURL=CardProductionBoxComponent.js.map